import(/* webpackMode: "eager" */ "/vercel/path0/admin2/app/login/page.tsx");
